var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"container--fluid"},[_c('div',{attrs:{"slot":"widget-content"},slot:"widget-content"},[_c('div',{attrs:{"id":"app"}},[_c('v-app',{attrs:{"id":"inspire"}},[_c(_vm.component,{tag:"component",attrs:{"props-filter":_vm.filter,"props-model":_vm.model,"props-data-request":_vm.dataRequest}})],1)],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }